(function($){
  $(function(){

    // Setting Up Global Variables to be used in JS - Denotes which template is which so JavaScript is used only on proper templates
    var BODY      	      	  = $('body'),
        IS_INDEX              = (BODY.hasClass('index-template')) ? true : false,
        IS_COLLECTION         = (BODY.hasClass('collection-template')) ? true : false,
        IS_COLLECTION_LISTING = (BODY.hasClass('list-collections-template')) ? true : false,
        IS_PRODUCT            = (BODY.hasClass('product-template')) ? true : false,
        IS_PRODUCT            = (BODY.hasClass('product-template')) ? true : false,
        IS_BLOG               = (BODY.hasClass('blog-template')) ? true : false,
        IS_ARTICLE            = (BODY.hasClass('article-template')) ? true : false,
        IS_SEARCH             = (BODY.hasClass('search-template')) ? true : false,
        IS_PAGE	              = (BODY.hasClass('page-template')) ? true : false,
        IS_CART               = (BODY.hasClass('cart-template')) ? true : false,
        HAS_PRODUCTS          = ($('.product').length > 0) ? true : false;

    if(IS_INDEX){
      var swiper = new Swiper('#hero-slider', {
        pagination: '#hero-slider .swiper-pagination',
        paginationClickable: true,
        prevButton: '#hero-slider .swiper-button-prev',
        nextButton: '#hero-slider .swiper-button-next',
        loop: true
      });
    }

    // Mobile Navigation
    var mmStatus = 'closed';
    function closeMM(){
      mmStatus = 'closed';
      $('#mobile-navigation-toggle').toggleClass('opened');
      $('body').removeClass('nav-opened');
    }
    function openMM(){
      mmStatus = 'opened';
      $('body').addClass('nav-opened');
      $('#mobile-navigation-toggle').toggleClass('opened');
    }

    $('#mobile-navigation-toggle').on('click', function(){
      if (mmStatus == 'closed'){
        openMM();
      } else if (mmStatus == 'opened') {
        closeMM();
      }
      return false;
    });

    $('.mobile-dropdown-toggle').on('click', function(){
      $(this).toggleClass('fa-plus-circle fa-times');
      $(this).next().toggle();
    });

    // main navigation
    function toggleDD(){
      $(this).toggleClass('hovered');
      $('.sub-navigation-wrapper', this).toggleClass('sub-navigation-wrapper-shown');
    };

    var $nav = $('#main-navigation');
    var hoverConfig = {
      over: toggleDD,
      timeout: 250,
      interval: 50,
      out: toggleDD
    };

    $nav.find("li.has-sub-navigation").each(function(){
      $(this).hoverIntent(hoverConfig);
    });

    // search toggle
    var $mainHeader   = $('#main-header'),
        $searchToggle = $('#search-icon'),
        $searchInput  = $('#main-header-search-form-input');

    $searchToggle.on('click', function(){
      $mainHeader.toggleClass('search-shown');
      $searchInput.focus();
    });

    $searchInput.focusout(function(){
      $searchInput.val('');
      $mainHeader.removeClass('search-shown');
    });

    // search autocomplete
    var cache = {};
    $searchInput.autocomplete({
      source: function(request, response){
        if (request.term in cache){
          response(cache[request.term]);
          return;
        }
        $.ajax({
          url: "/search",
          data: {
          q: "*" + request.term + "*",
          type: "product",
          view: "json",
        },
               dataType: "json",
               success: function(data){
          if (data.length){
            cache[request.term] = data;
          }
          if (data.length > 6){
            $('.ui-autocomplete').show();
          } else {
            $('.ui-autocomplete').hide();
          }
          response(data);
        }
      });
    },
	minLength: 2,
    focus: function(event, ui) {
      $('div.autoprod').removeClass('ui-state-focus');
      $('#autoprod' + ui.item.id).addClass('ui-state-focus');
    },
      select: function(event, ui){
        window.location = ui.item.url;
      },
  }).data( 'ui-autocomplete' )._renderItem = function(ul, item) {
    var elemHTML = '<div id="autoprod' + item.id +'" class="autoprod"><div class="autoimg"><img src="' + item.thumb + '" class="autothumb" /></div><div class="autotext"><h5 class="autotitle">' + item.label + '</h5><a href="' + item.url + '" class="autocollection">' + item.type + '</a><span class="autoprice">' + item.price +'</span></div>';
    return $( '<li class="ui-menu-item" role="presentation">').append(elemHTML).appendTo(ul);
  };

  $(window).on('resize', function(){
    $('#main-header-search-form-input').blur().val('');
  });

});
})(jQuery)